export default __webpack_public_path__ + "static/media/no-registration4.a8d2d9c2.svg";